import axiosInstance from './AxiosInstance';

const API_URL = 'traininghistory';

export const getTraininghistory = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching traininghistory', error);
        throw error;
    }
};

export const approveTraining = async (id, email) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/approvetraining`, { id: id, email: email });
        return response.data;
    } catch (error) {
        console.error(`Error updating approve training with email ${email}`, error);
        throw error;
    }
};


export const traininghistoryByEmail = async (email) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/${email}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching traininghistory with email ${email}`, error);
        throw error;
    }
};


export const getTraininghistoryById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching traininghistory with id ${id}`, error);
        throw error;
    }
};

export const createTraininghistory = async (traininghistory) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, traininghistory);
        return response.data;
    } catch (error) {
        console.error('Error creating traininghistory', error);
        throw error;
    }
};

export const updateTraininghistory = async (id, traininghistory) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...traininghistory });
        return response.data;
    } catch (error) {
        console.error(`Error updating traininghistory with id ${id}`, error);
        throw error;
    }
};

export const deleteTraininghistory = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting traininghistory with id ${id}`, error);
        throw error;
    }
};

